
  <app-mwe-table [columns]="columns" [data]="data" [totalEntries]="totalEntries" [showPagination]="false" [showHeader]="false" (selectedAction)="selectedAction($event)" [totalEntries]="totalEntries"
></app-mwe-table>
<form [formGroup]="branchForm">


    <div class="card p-4 mt-2 mb-2" *ngIf="isProceed">
<div class="row mt-2 branch-info-height">
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Branch Name<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 branch-custome-error-message">
                <input matInput formControlName="brandName" placeholder="Enter Branch Name" />
                <mat-error class="error-message error-msg" *ngIf="branchForm.get('brandName')?.hasError('required')"
                   >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                    Branch Name is Required
                </mat-error>
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('brandName')?.hasError('maxlength') && branchForm.get('brandName')?.touched"
                    >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                    Limit Exceeded: Max 150 characters
                </mat-error>
            
            </mat-form-field>
           
        </div>
    </div>
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Contact Person<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 branch-custome-error-message ">
                <input matInput   formControlName="contactPerson"  (keypress)="onlyText($event)" placeholder="Enter Contact Person Name">          
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('contactPerson')?.hasError('required')" ><img
                        class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Contact Person is Required</mat-error>
                        <mat-error class="error-message error-msg" *ngIf="branchForm.get('contactPerson')?.hasError('maxlength') && (branchForm.get('contactPerson')?.dirty || branchForm.get('contactPerson')?.touched)" >
                            <img class="error-icon" style="margin-right: 5px;" loading="lazy" alt="" src="./../../assets/images/alert.svg" />Limit Exceeded : Max 50 characters
                        </mat-error>             
            </mat-form-field>
        </div>
    </div>
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Contact Phone Number<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 branch-custome-error-message">
                <input matInput formControlName="contactPhone"  placeholder="Enter Phone Number">
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('contactPhone')?.hasError('required')&& branchForm.get('contactPhone')">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is Required
                </mat-error>
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('contactPhone')?.hasError('minlength') && branchForm.get('contactPhone')?.touched" >
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Enter atleast 10
                    digits
                </mat-error>
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('contactPhone')?.hasError('maxlength')&& branchForm.get('contactPhone')?.touched">
                    <img class="error-icon" style="margin-right: 5px;" loading="lazy" alt="" src="./../../assets/images/alert.svg" />Limit Exceeded : Max 15 digits
                </mat-error>
                <mat-error class="error-message error-msg"
                *ngIf="branchForm.get('contactPhone')?.hasError('pattern')&& branchForm.get('contactPhone')?.touched">
                <img class="error-icon" style="margin-right: 5px;" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Enter a valid Phone Number
            </mat-error>
            </mat-form-field>
        </div>
    </div>
    <div class="col-lg-3 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Contact Email<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 branch-custome-error-message">
                <input matInput  formControlName="contactEmail" placeholder="Enter Email">
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('contactEmail')?.hasError('required') "  style="text-wrap: nowrap;"><img
                        class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Email is Required</mat-error>
                        <mat-error class="error-message error-msg"
                        *ngIf="branchForm.get('contactEmail')?.hasError('pattern') && branchForm.get('contactEmail')?.touched" >
                        <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> 
                        Enter a valid Email.
                      </mat-error>                      
            </mat-form-field>
        </div>
    </div>
</div>
<div class="row mt-2">
    
    <div class="col-lg-6 my-2">
        <div >
            <p class="med-world-basic-font med-world-basic-font__medium secondary_black_color m-0">Address<span class="text-danger">*</span></p>
        </div>
        <div>
            <mat-form-field appearance="outline" class="fields input-font w-100 branch-custome-error-message">
                <input matInput formControlName="address" placeholder="Enter Address">
                <mat-error class="error-message error-msg" *ngIf="branchForm.get('address')?.hasError('required')"  style="text-wrap: nowrap;"><img
                        class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Address is
                    Required</mat-error>            
                <mat-error class="error-message error-msg"
                    *ngIf="branchForm.get('address')?.hasError('maxlength') && branchForm.get('address')?.touched"
                    style="text-wrap: nowrap;">
                    <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" />
                    Limit Exceeded: Max 150 characters
                </mat-error>
            
            </mat-form-field>
        </div>
    </div>
</div>
        

<div class="mt-3">

    <button class="mwe-button mwe-button--primary ps-3 pe-3" (click)=" addBranchInformation()"
       >
        <span class="deltext">Save</span>
    </button>&nbsp;&nbsp;
  
    <button class="mwe-button mwe-button--secondary ps-3 pe-3" (click)=" toggleCancel()"
       >
        <span class="deltext">Cancel</span>
    </button>
</div>
    </div>

    <div *ngIf="!isProceed&&!isMore" class="mt-2 mb-2" style="margin-left: 10px;">
        <button class="d-flex more" (click)=" toggleIsProceed()"
        ><mat-icon>add</mat-icon>
         <span class="deltext">Add</span>
     </button>
    </div>
    <div *ngIf="!isProceed&&isMore" class="mt-2 mb-2" style="margin-left: 10px;" >
     <button class="d-flex more" (click)=" toggleIsProceed()"
     ><mat-icon>add</mat-icon>
      <span class="deltext">Add More</span>
  </button>
</div>
    


</form>